/**
 * Component is used to show store's regular hours based on its identifier.
 *
 * @attr {String} [title-hours] - The title for regular open hours block
 * @attr {String} store-code - an identifier of a store
 * @attr {String} [closed-hours] - Label for store without opening hours
 * @prop {Array} openHours - an array with details about regular working hours of a certain store
 *
 */

import { html } from 'lit-element';

import { LightLitElement } from '@elab/components';
import { actions, selectors } from '@elab/core/store/store-details';
import { selectors as cartSelectors } from '@elab/core/store/cart';
import connect from '@elab/core/store/connect';

export class StoreDetailsHours extends LightLitElement {
    static get properties() {
        return {
            storeUid: {
                type: String,
                attribute: 'store-code',
            },
            closedLabel: {
                type: String,
                attribute: 'closed-hours',
            },
            cssClass: {
                type: String,
                attribute: 'css-class',
            },
            openHours: { type: Array },
        };
    }

    firstUpdated() {
        this.dispatchEvent(new CustomEvent('get-store-details'));
    }

    render() {
        return this.openHours.length
            ? html`
                  <div class="hours-card">
                      <v-slot name="title"></v-slot>
                      <div class="hours-card__hours">
                          <e2-hours-table
                              .closedLabel="${this.closedLabel}"
                              .openHours="${this.openHours}"
                              css-class="${this.cssClass}"
                          ></e2-hours-table>
                      </div>
                  </div>
              `
            : html``;
    }
}

const mapDispatchToEvents = (dispatch, ctx) => ({
    'get-store-details': () => dispatch(actions.getStoreDetails(ctx.storeUid)),
});

const mapStateToProps = state => {
    const store = selectors.getDataStore(state) || {};
    const openHours = (store.openingHours && store.openingHours.weekDayOpeningList) || [];
    return { openHours };
};

const mapStateToPropsOnDelivery = state => {
    const pickupPoint = cartSelectors.getDeliveryPointOfService(state);

    return {
        openHours: (pickupPoint.openingHours && pickupPoint.openingHours.weekDayOpeningList) || [],
    };
};

export default () => {
    customElements.define(
        'e2-store-details-hours',
        connect(mapStateToProps, mapDispatchToEvents)(StoreDetailsHours),
    );

    customElements.define(
        'e2-delivery-store-details-hours',
        connect(mapStateToPropsOnDelivery)(StoreDetailsHours),
    );
};
